/* eslint-disable import/prefer-default-export */
import api from "./axios";

export const transformQuery = (query) => {
  const queryString = Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join("&");
  if (queryString.length === 0) {
    return "";
  } else {
    return `?${queryString}`;
  }
};

export async function getSuppliers(params) {
  let query = "";
  if (params) {
    query = transformQuery(params);
  }
  const response = await api.get(`/suppliers${query}`);
  return response;
}

export async function getSupplier(supplierId) {
  const response = await api.get(`/suppliers/${supplierId}`);
  return response;
}

export async function postSupplier(supplier) {
  const response = await api.post("/suppliers", supplier);
  return response;
}

export async function deleteSupplier(supplierId) {
  const response = await api.delete(`/suppliers/${supplierId}`);
  return response;
}

export async function putSupplier(supplier, supplierId) {
  const response = await api.put(`/suppliers/${supplierId}`, supplier);
  return response;
}
